exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-container[data-v-2e2745dc]{padding:20px 20px 20px 0px;width:100%;height:94vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden;background:#fff}.image-container img[data-v-2e2745dc]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);

// exports
